import HttpClient from './utils/HttpClient';
import APIError from '../errors/APIError';

import { ISize } from '../models';

class SizesService {
  private httpClient = HttpClient;

  public async listSizes(companyId: number, type: number): Promise<ISize[]> {
    try {
      const response = await this.httpClient.get(
        `/companies/${companyId}/sizes?type=${type}`,
      );

      return response.data;
    } catch (error) {
      const parsedError = error as any;

      let errorMessage = parsedError?.response?.data?.message;

      if (!errorMessage) {
        errorMessage = 'Erro ao tentar listar os tamanhos';
      }

      throw new APIError(errorMessage);
    }
  }

  public async createSize(companyId: number, data: any): Promise<ISize> {
    try {
      const response = await this.httpClient.post(
        `/companies/${companyId}/sizes`,
        data,
      );

      return response.data;
    } catch (error) {
      const parsedError = error as any;

      let errorMessage = parsedError?.response?.data?.message;

      if (!errorMessage) {
        errorMessage = 'Erro ao tentar cadastrar o tamanho';
      }

      throw new APIError(errorMessage);
    }
  }

  public async generate(companyId: number, type: number): Promise<ISize[]> {
    try {
      const response = await this.httpClient.post(
        `/companies/${companyId}/sizes/generate`,
        { type },
      );

      return response.data;
    } catch (error) {
      const parsedError = error as any;

      let errorMessage = parsedError?.response?.data?.message;

      if (!errorMessage) {
        errorMessage = 'Erro ao tentar gerar os tamanhos';
      }

      throw new APIError(errorMessage);
    }
  }

  public async updateSizes(companyId: number, sizes: any): Promise<ISize[]> {
    try {
      const response = await this.httpClient.patch(
        `/companies/${companyId}/sizes`,
        { sizes },
      );

      return response.data;
    } catch (error) {
      const parsedError = error as any;

      let errorMessage = parsedError?.response?.data?.message;

      if (!errorMessage) {
        errorMessage = 'Erro ao tentar editar os tamanhos';
      }

      throw new APIError(errorMessage);
    }
  }

  public async deleteSize(companyId: number, sizeId: number): Promise<void> {
    try {
      await this.httpClient.delete(`/companies/${companyId}/sizes/${sizeId}`);
    } catch (error) {
      const parsedError = error as any;

      let errorMessage = parsedError?.response?.data?.message;

      if (!errorMessage) {
        errorMessage = 'Erro ao tentar excluir o tamanho';
      }

      throw new APIError(errorMessage);
    }
  }
}

export default new SizesService();
